/** 
 * Detects whether an HTML element is overflowing its width. 
 * In other words, true means the element has been truncated or is showing scrollbars,
 * depending on the CSS overflow property.
 * 
 * @param {HTMLElement} element - The HTML element to check for overflow.
 * @returns {boolean} - True if the element is overflowing, false otherwise.
 */
export function isOverflowingX(element) {
  return element.offsetWidth < element.scrollWidth;
}

/** 
 * Detects whether an HTML element is overflowing its height. 
 * In other words, true means the element has been truncated or is showing scrollbars,
 * depending on the CSS overflow property.
 * 
 * @param {HTMLElement} element - The HTML element to check for overflow.
 * @returns {boolean} - True if the element is overflowing, false otherwise.
 */
export function isOverflowingY(element) {
  return element.offsetHeight < element.scrollHeight;
}


/** 
 * Detects whether an HTML element is overflowing its height or width. 
 * In other words, true means the element has been truncated or is showing scrollbars,
 * depending on the CSS overflow property.
 * 
 * @param {HTMLElement} element - The HTML element to check for overflow.
 * @returns {boolean} - True if the element is overflowing, false otherwise.
 */
export function isOverflowing(element) {
  return isOverflowingX(element) || isOverflowingY(element);
}